import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    match: String,
    notMatch: String
  }

  initialize() {
    this.observer = null
  }

  connect() {
    const matcher = () => {
      const match = this.element.querySelector(this.matchValue || this.notMatchValue)
      if ((this.matchValue && match) || (this.notMatchValue && !match))
        return true
      return false
    }

    this.observer = new MutationObserver((_mutationList, _observer) => {
      if (matcher()) {
        Turbo.visit(this.urlValue)
        this.observer.disconnect()
      }
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
  }
}
